export default "__VITE_ASSET__D9B_WWTx__"